import React, { FC } from 'react';
import { ContainerBase } from '.';
import { PageHeader } from '../pageHeader';

// export const PageTitle = styled.h1`
// 	font-size: 26px;
// 	margin-bottom: 30px;
// 	color: ${(props) => props.theme.app.primary_dark};
// `;

// Generic vertical layout

interface BlocksPageLayoutProps {
    title: string;
    pageKey?: string;
    className?: string;
    children?: React.ReactNode;
}

export const BlocksPageLayout: FC<BlocksPageLayoutProps> = ({ title, pageKey, className, children }) => {
    return (
        <ContainerBase className={className}>
            <PageHeader title={title} pageKey={pageKey} />
            {children}
        </ContainerBase>
    );
};
